var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hello screen-spacing" }, [
    _c(
      "div",
      {},
      [
        _c("div", { staticClass: "h1 display-inline" }, [
          _vm._v("Generate QR code "),
          _c(
            "button",
            {
              staticClass: "tooltip-btn h3",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.alertInfo()
                },
              },
            },
            [_c("span", { staticClass: "question-mark" }, [_vm._v("?")])]
          ),
        ]),
        _c("SelectVenue", {
          ref: "venueDropDown",
          on: { updateVenue: _vm.updateVenue },
        }),
        _c("div", { staticClass: "form-text ms-2" }, [
          _vm._v("This name appears in the flyer header."),
        ]),
      ],
      1
    ),
    _c("p", { staticClass: "mt-3 ms-2" }, [
      _vm._v("Print your own QR code? "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.showCodes,
            expression: "showCodes",
          },
        ],
        staticClass: "btn pl-3 ml-2",
        attrs: {
          type: "checkbox",
          id: "TableName",
          "aria-describedby": "emailHelp",
        },
        domProps: {
          checked: Array.isArray(_vm.showCodes)
            ? _vm._i(_vm.showCodes, null) > -1
            : _vm.showCodes,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.showCodes,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.showCodes = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.showCodes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.showCodes = $$c
            }
          },
        },
      }),
    ]),
    !_vm.showCodes && _vm.qrcodeString
      ? _c("div", { staticClass: "ms-2" }, [
          _c("div", { staticClass: "mb-3" }, [
            _vm._m(0),
            _c("div", { staticClass: "row g-2 align-items-center" }, [
              _c("div", { staticClass: "col-auto" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.color,
                      expression: "color",
                    },
                  ],
                  staticClass: "form-control form-control-color",
                  attrs: {
                    id: "accent",
                    type: "color",
                    value: "#000000",
                    title: "Choose color",
                  },
                  domProps: { value: _vm.color },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.color = $event.target.value
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.color,
                      expression: "color",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "accentHex", type: "text", value: "#000000" },
                  domProps: { value: _vm.color },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.color = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", {
              staticClass: "mt-2 rounded",
              staticStyle: { height: "20px" },
              attrs: { id: "accentStripe" },
            }),
          ]),
          _c("div", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btnAccent",
                  attrs: { id: "downloadPrimary", type: "button" },
                },
                [_vm._v("Download")]
              ),
              _vm._m(1),
              _c("ul", { staticClass: "dropdown-menu" }, [
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { "data-variant": "flyer" },
                      on: { click: _vm.makeFlyerPdf },
                    },
                    [_vm._v("Flyer PDF")]
                  ),
                ]),
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { "data-variant": "large" },
                      on: { click: _vm.downloadSingleTable },
                    },
                    [_vm._v("Large Table QR")]
                  ),
                ]),
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { "data-variant": "small" },
                      on: { click: _vm.downloadGrid },
                    },
                    [_vm._v("Small Table QR")]
                  ),
                ]),
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { "data-variant": "stage" },
                      on: { click: _vm.downloadStage },
                    },
                    [_vm._v("Stage QR")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "mb-2" }, [
            _c("label", { staticClass: "form-label mt-2" }, [
              _vm._v("Flyer description"),
            ]),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.descriptionText,
                  expression: "descriptionText",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "desc",
                rows: "4",
                maxlength: "160",
                placeholder:
                  "Pick up at the Main Bar. We’ll send you a text when it’s ready!",
              },
              domProps: { value: _vm.descriptionText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.descriptionText = $event.target.value
                },
              },
            }),
            _vm._m(2),
          ]),
        ])
      : _vm._e(),
    _vm.showCodes && _vm.qrcodeString
      ? _c("div", { staticClass: "barcode-container" }, [
          _c("h1", [
            _vm._v(
              _vm._s(this.currentVenue.venue_name) +
                ": " +
                _vm._s(
                  "https://vibe-tap.com/open?venueID=" + _vm.currentVenueId
                )
            ),
          ]),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.tableList, function (table, index) {
              return _c("div", { key: index, staticClass: "fs-3 mt-3" }, [
                _c("div", [
                  _c("b", [_vm._v(_vm._s(table.name))]),
                  _vm._v(
                    ": " +
                      _vm._s("https://vibe-tap.com/open?tableID=" + table._id)
                  ),
                ]),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label d-flex align-items-center gap-2" },
      [
        _c("span", [_vm._v("Select accent color")]),
        _c("span", { staticClass: "badge bg-light text-muted" }, [
          _vm._v("affects header + buttons"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btnAccent dropdown-toggle dropdown-toggle-split",
        attrs: {
          type: "button",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Toggle dropdown"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "form-text" }, [
        _vm._v("Shown under the QR on the flyer."),
      ]),
      _c("div", { staticClass: "form-text" }, [
        _c("span", { attrs: { id: "descCount" } }, [_vm._v("0")]),
        _vm._v("/160"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }